module.exports = __webpack_public_path__ + "static/media/BoxPlotQ7_2.9ba90bed.svg";